import http from './http';
import localStorageService from "../services/localStorage";

export default {
  initEnums() {
    return http().get(`/v1/client_store/setup_enums`);
  },
  initData() {
    return http().get(`/v1/client_store/setup_data`);
  },
  initMarketStepOne(account_id) {
    let only = ["market", "tags", "contactTypes", "campaigns", "integrations", "integrationPhoneNumbers", "dealsCountThisMonth"];
    // let only = ["market", "tags", "contactTypes", "campaigns", "integrations"];

    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',') + "&omit_defaults=true"
    }

    return http().get(`/v1/client_store/market/${account_id}?${queryString}`);
  },
  initMarketStepTwo(account_id) {
    // let only = ["inboxLeadsItemLite", "inboxInboundCommsItemLite", "inboxInboundCommsItemLiteComms", "incompleteTasks", "pendingAppointments"];
    let only = ["inboxLeadsItemLite" ,"inboxInboundCommsItemLite", "inboxInboundCommsItemLiteComms"];

    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',') + "&omit_defaults=true"
    }

    return http().get(`/v1/client_store/market/${account_id}?${queryString}`);
  },
  initMarketStepThree(account_id) {
    let only = ["incompleteTasks", "pendingAppointments"];

    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',') + "&omit_defaults=true"
    }

    return http().get(`/v1/client_store/market/${account_id}?${queryString}`);
  },
  // initAccount(account_id) {
  //   return http().get(`/v1/client_store/account/${account_id}`);
  // },
  initAccountStepOne(account_id) {
    let only = ["account", "statuses", "pipelineViews", "users", "customFields", "snippets"];

    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',') + "&omit_defaults=true"
    }

    return http().get(`/v1/client_store/account/${account_id}?${queryString}`);
  },
  initAccountStepTwo(account_id) {
    let only = ["fusTemplates", "callScripts", "tableConfigurations", "pipeline_counts"];

    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',') + "&omit_defaults=true"
    }

    return http().get(`/v1/client_store/account/${account_id}?${queryString}`);
  },
  initUser(user_id) {
    return http().get(`/v1/client_store/user/${user_id}?with=badges`);
  },
  initRecord(record_id, only) {
    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',')
    }

    return http().get(`/v1/client_store/activeRecord/${record_id}?${queryString}`);
  },
  getRecordProp(data) {
    return http().get(`/v1/client_store/activeRecord/${data.record_id}/${data.prop}`);
  },

  initContact(contact_id, only) {
    let queryString = '';
    if (only) {
      queryString = 'with=' + only.join(',')
    }

    return http().get(`/v1/client_store/activeContact/${contact_id}?${queryString}`);
  },
  getContactProp(contact_id, prop) {
    return http().get(`/v1/client_store/activeContact/${contact_id}/${prop}`);
  },
  // getOrphanedRecords() {
  //   const account_id = localStorageService.getAuthUser().account_id;
  //   return http().get(`/v1/client_store/fus/${account_id}/orphanedRecords`);
  // },
  getFusSchuledContacts(marketId) {
    return http().get(`/v1/client_store/fus/${marketId}/scheduledContacts`);
  },
  getTasks(marketId, filters) {
    return http().get(`/v1/client_store/upNext/${marketId}/incompleteTasks`, {
      params: filters,
      paramSerializer: (params) => {
        return Object.keys(params)
          .map(key => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');
      }
    });
  },
  getAppointments(accountId, filters) {
    return http().get(`/v1/client_store/upNext/${accountId}/pendingAppointments`, {
      params: filters,
      paramSerializer: (params) => {
        return Object.keys(params)
          .map(key => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');
      }
    });
  },
  getComms(marketId) {
    return http().get(`/v1/client_store/comms/${marketId}/comms`);
  },
  getFilteredComms(data) {
    return http().get(`/v1/client_store/comms/${data.marketId}/${data.filter}`);
  },
  getFromUrl(url) {
    return http().get(url);
  },


  /**
   * Pipeline States
   */
  initContactingState(market_id, query = '') {
    return http().get(`/v1/client_store/contactingState/${market_id}/records` + query);
  },
  initActiveState(marketId, filters) {
    return http().get(`/v1/client_store/activeState/${marketId}`, {
      params: filters,
      paramSerializer: (params) => {
        return Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");
      },
    });
  },
  initRecordsInManualFollowUp(market_id, query) {
    return http().get(`/v1/client_store/recordsInManualFollowUp/${market_id}?${query}`);
  },
  initRecordsInAutomatedFollowUp(market_id, query) {
    return http().get(`/v1/client_store/recordsInAutomatedFollowUp/${market_id}?${query}`);
  },
  initCompletedState(market_id) {
    return http().get(`/v1/client_store/completedState/${market_id}`);
  },

  /**
   * Active Inbox
   */
  initActiveInboxLeadItem(recordId) {
    return http().get(`/v1/client_store/activeInboxLeadItem/${recordId}`);
  },
  initActiveInboxInboundCommItem(contactId) {
    return http().get(`/v1/client_store/activeInboxInboundCommItem/${contactId}`);
  },
  getActiveInboxInboundCommItemCommLogs(contactId, page = 1, size = 20) {
    return http().get(`/v1/client_store/activeInboxInboundCommItem/${contactId}?page=${page}&size=${size}&with=communicationLogs&omit_defaults=true`);
  },

  initActiveFollowUpStateItem(recordId, page = 1, size = 20) {
    return http().get(`/v1/client_store/activeFollowUpStateItem/${recordId}?page=${page}&size=${size}`);
  },
  initActivePipelineView(pipeline_view_id) {
    return http().get(`/v1/client_store/activePipelineView/${pipeline_view_id}`);
  },

  /**
   * Active Text Modal
   */
  initActiveTextRecordModal(recordId) {
    return http().get(`/v1/client_store/activeTextRecordModal/${recordId}`);
  },
  initActiveTextContactModal(contactId, page = 1, size = 20) {
    return http().get(`/v1/client_store/activeTextContactModal/${contactId}?page=${page}&size=${size}`);
  },

  /**
   * User Dashboard
   */
  initDashboardBadges(userId) {
    return http().get(`/v1/client_store/dashboard/${userId}`);
  },
  initDashboardContacting(userId, selectedDate) {
    return http().get(`/v1/client_store/dashboardContacting/${userId}?datetime=${encodeURIComponent(selectedDate)}`)
  },
  initDashboardFollowUp(userId, selectedDate) {
    return http().get(`/v1/client_store/dashboardFollowUp/${userId}?datetime=${encodeURIComponent(selectedDate)}`)
  },
  initDashboardActive(userId, selectedDate) {
    return http().get(`/v1/client_store/dashboardActive/${userId}?datetime=${encodeURIComponent(selectedDate)}`)
  },
  initDashboardAppointments(selectedDate, type = 'today') {
    return http().post(`/v1/user_dashboard/appointments`, {datetime: selectedDate, type: type});
  },
  initDashboardTaskBadges() {
    return http().get(`/v1/user_dashboard/tasks-count`);
  },
  initDashboardTasks(selectedDate) {
    return http().post(`/v1/user_dashboard/tasks`, {datetime: selectedDate});
  },
}
